import { createGetEndpoint } from '@sonar-software/sonar-http';

export type SetupAuditTrailSourceNamePrefixResponse = {
	sourceNamespacePrefixes: Array<string>;
};

export const getSetupAuditTrailSourceNamePrefix = createGetEndpoint<void, SetupAuditTrailSourceNamePrefixResponse>(
	'/api/v3/setup-audit-trail/source-namespace-prefixes'
);
